const firstDateWithData = new Date('2024-02-25');

export const calculateWeeksToGivenDate = () => {
	const differenceInMs = firstDateWithData.getTime() - new Date().getTime();
	const weeksDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24 * 7));
	return weeksDifference;
};
